$(function () {
    // Masks
    var maskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11
                ? '(00) 00000-0000'
                : '(00) 0000-00009'
        },
        options = {
            onKeyPress: function (val, e, field, options) {
                field.mask(maskBehavior.apply({}, arguments), options)
            },
        }
    var telFields = $('.form-tel, [data-mask-type="tel"]')
    telFields.each(function () {
        var field = $(this)
        var rawValue = field.val().replace(/\D/g, '')
        if (rawValue) {
            field.val(rawValue)
        }
    })
    telFields.mask(maskBehavior, options)
    $('.form-cep, [data-mask-type="cep"]').mask('00000-000')
    $('.form-cpf, [data-mask-type="cpf"]').mask('000.000.000-00')
    $('.form-cnpj, [data-mask-type="cnpj"]').mask('00.000.000/0000-00')

    // WooCommerce AJAX URL helper
    function getWcAjaxUrl(endpoint) {
        var sources = [
            typeof wc_add_to_cart_params !== 'undefined' ? wc_add_to_cart_params : null,
            typeof wc_checkout_params !== 'undefined' ? wc_checkout_params : null,
            typeof wc_cart_fragments_params !== 'undefined' ? wc_cart_fragments_params : null,
        ]
        for (var i = 0; i < sources.length; i++) {
            if (sources[i] && sources[i].wc_ajax_url) {
                return sources[i].wc_ajax_url.replace('%%endpoint%%', endpoint)
            }
        }
        return '/?wc-ajax=' + endpoint
    }

    // Move S/N checkbox inside number field
    $('#lkn_billing_checkbox_field').appendTo('#billing_number_field')
    $('#lkn_shipping_checkbox_field').appendTo('#shipping_number_field')

    // ViaCEP autofill for WooCommerce address fields
    $(document).on('blur', '#billing_postcode, #shipping_postcode', function () {
        var $cepInput = $(this)
        var prefix = $cepInput.attr('id').replace('_postcode', '')
        var cep = $cepInput.val().replace(/\D/g, '')
        if (cep.length !== 8) return

        $.getJSON('https://viacep.com.br/ws/' + cep + '/json/', function (data) {
            if (data.erro) return
            $('#' + prefix + '_address_1').val(data.logradouro)
            $('#' + prefix + '_neighborhood').val(data.bairro)
            $('#' + prefix + '_city').val(data.localidade)
            var $stateSelect = $('#' + prefix + '_state')
            if ($stateSelect.length) {
                $stateSelect.val(data.uf).trigger('change')
            }
            $('#' + prefix + '_number, [name="' + prefix + '_number"]').first().focus()
        })
    })

    // Move Shipping Calculator to Placeholder
    function moveShippingCalc() {
        var $shippingCalc = $('.woo-better-parent-container')
        var $shippingPlaceholder = $('.produto-single-shipping-placeholder')
        if ($shippingCalc.length && $shippingPlaceholder.length) {
            $shippingPlaceholder.append($shippingCalc)
            return true
        }
        return false
    }
    if (!moveShippingCalc()) {
        var shippingObserver = new MutationObserver(function () {
            if (moveShippingCalc()) {
                shippingObserver.disconnect()
            }
        })
        shippingObserver.observe(document.body, { childList: true, subtree: true })
    }

    // Sticky Header Shrink
    var $header = $('.header-menu')
    $(window).on('scroll', function () {
        $header.toggleClass('header-scrolled', $(this).scrollTop() > 50)
    })

    // Get container offset
    offsetWidth()
    $(window).on('resize', function () {
        offsetWidth()
    })

    function offsetWidth() {
        var containerOffset = $('.container').offset().left

        // Aplicar padding-left apenas em desktop (lg breakpoint = 992px)
        // Evitar aplicar quando modos de contraste estão ativos (podem afetar offset)
        if (
            $(window).width() >= 992 &&
            !$('body').hasClass('high-contrast') &&
            !$('body').hasClass('grayscale-contrast')
        ) {
            $('.offcanvas-offset').css('padding-left', containerOffset + 12)
        } else {
            $('.offcanvas-offset').css('padding-left', '')
        }
        $('.container-offset').css('width', containerOffset)
    }

    // Smooth Scrolling to Anchor Links
    $('.smooth-scroll').on('click', function (event) {
        var $anchor = $(this)

        $('html, body')
            .stop()
            .animate(
                {
                    scrollTop: $($anchor.attr('href')).offset().top - 300,
                },
                100
            )

        event.preventDefault()
    })

    // Fancybox
    Fancybox.bind('[data-fancybox]', {})

    // scrollCue
    if (typeof scrollCue !== 'undefined') {
        scrollCue.init({
            duration: 600,
            interval: -200,
            percentage: 0.95,
        })
        $(window).on('load', function () {
            scrollCue.update()
        })
    }

    // WooCommerce Quantity Buttons
    $(document).on(
        'click',
        '.quantity-btn-minus, .quantity-btn-plus',
        function () {
            var $input = $(this).closest('.quantity').find('input.qty')
            var currentVal = parseFloat($input.val()) || 0
            var step = parseFloat($input.attr('step')) || 1
            var min = parseFloat($input.attr('min')) || 0
            var max = parseFloat($input.attr('max')) || Infinity

            if ($(this).hasClass('quantity-btn-plus')) {
                if (currentVal < max) {
                    $input.val(currentVal + step).trigger('change')
                }
            } else {
                if (currentVal > min) {
                    $input.val(currentVal - step).trigger('change')
                }
            }
        }
    )

    // WooCommerce Hide Empty Cart Badge
    function hideEmptyCartBadge() {
        var $badge = $('.header-cart-count')
        if ($badge.length) {
            var count = parseInt($badge.text(), 10)
            $badge.toggle(count > 0)
        }
    }
    hideEmptyCartBadge()
    $(document.body).on(
        'wc_fragments_loaded wc_fragments_refreshed',
        hideEmptyCartBadge
    )

    // Checkout Inline Validation
    $(document.body).on('checkout_error', function () {
        $('.checkout-field-error').remove()
        $('.woocommerce-invalid').removeClass('woocommerce-invalid')

        $('.woocommerce-error li[data-id]').each(function () {
            var fieldId = $(this).data('id')
            var message = $(this).text().trim()
            var $field = $('#' + fieldId + '_field')

            if ($field.length) {
                $field.addClass('woocommerce-invalid')
                $field.append(
                    '<span class="checkout-field-error">' + message + '</span>'
                )
            }
        })

        var $firstError = $('.woocommerce-invalid').first()
        if ($firstError.length) {
            $('html, body').animate(
                { scrollTop: $firstError.offset().top - 150 },
                400
            )
        }
    })

    // Checkout Coupon Apply
    $(document).on('click', '.woocommerce-remove-coupon', function (e) {
        e.preventDefault()
        var couponCode = $(this).data('coupon')

        $.ajax({
            type: 'POST',
            url: getWcAjaxUrl('remove_coupon'),
            data: {
                coupon: couponCode,
                security: wc_checkout_params.remove_coupon_nonce,
            },
            complete: function () {
                $(document.body).trigger('update_checkout')
                $.get(window.location.href, function (html) {
                    var $newReview = $(html).find('#order_review')
                    if ($newReview.length) {
                        $('#order_review').html($newReview.html())
                    }
                })
            },
        })
    })

    $(document).on('click', '#checkout-apply-coupon', function () {
        var $btn = $(this)
        var couponCode = $('#coupon_code').val()
        if (!couponCode) return

        $btn.prop('disabled', true).text('...')
        $('.checkout-coupon-message').remove()

        $.ajax({
            type: 'POST',
            url: getWcAjaxUrl('apply_coupon'),
            data: {
                coupon_code: couponCode,
                security: wc_checkout_params.apply_coupon_nonce,
            },
            success: function (response) {
                $('.checkout-coupon-message').remove()
                var msgClass = response.indexOf('error') !== -1 || response.indexOf('Erro') !== -1 || response.indexOf('existe') !== -1
                    ? 'checkout-coupon-message checkout-coupon-error'
                    : 'checkout-coupon-message checkout-coupon-success'
                $('.checkout-coupon-row').after('<span class="' + msgClass + '">' + $(response).text().trim() + '</span>')
                $(document.body).trigger('update_checkout')
                $('#coupon_code').val('')
                $.get(window.location.href, function (html) {
                    var $newReview = $(html).find('#order_review')
                    if ($newReview.length) {
                        $('#order_review').html($newReview.html())
                    }
                })
            },
            complete: function () {
                $btn.prop('disabled', false).text('Enviar')
            },
        })
    })

    // Product Block Quantity Buttons
    function updateMinusBtnState($input) {
        var currentVal = parseInt($input.val(), 10) || 1
        var min = parseInt($input.attr('min'), 10) || 1
        var $wrap = $input.closest(
            '.produto-qty-wrap, .produto-single-qty-wrap'
        )
        var $minusBtn = $wrap.find('.produto-qty-minus')
        $minusBtn.toggleClass('produto-qty-btn-active', currentVal > min)
    }

    $(document).on('click', '.produto-qty-minus, .produto-qty-plus', function () {
        var $input = $($(this).data('input'))
        var currentVal = parseInt($input.val(), 10) || 1
        var min = parseInt($input.attr('min'), 10) || 1
        var max = parseInt($input.attr('max'), 10) || Infinity

        if ($(this).hasClass('produto-qty-plus') && currentVal < max) {
            $input.val(currentVal + 1)
        } else if ($(this).hasClass('produto-qty-minus') && currentVal > min) {
            $input.val(currentVal - 1)
        }
        updateMinusBtnState($input)
    })

    // Mini Cart / Checkout Quantity Buttons
    var cartQtyUpdating = false
    $(document).on('click', '.mini-cart-qty-minus, .mini-cart-qty-plus', function (e) {
        e.preventDefault()
        if (cartQtyUpdating) return
        cartQtyUpdating = true

        var $btn = $(this)
        var cartKey = $btn.data('cart-key')
        var $wrap = $btn.closest('.mini-cart-qty-wrap')
        var $valueEl = $wrap.find('.mini-cart-qty-value')
        var currentVal = parseInt($valueEl.text(), 10) || 1
        var newVal

        if ($btn.hasClass('mini-cart-qty-plus')) {
            newVal = currentVal + 1
        } else {
            newVal = currentVal - 1
        }

        $valueEl.text(newVal > 0 ? newVal : '...')

        $.ajax({
            type: 'POST',
            url: getWcAjaxUrl('alegria_update_mini_cart'),
            data: {
                cart_key: cartKey,
                quantity: newVal,
            },
            dataType: 'json',
            success: function (response) {
                if (response && response.fragments) {
                    $.each(response.fragments, function (key, value) {
                        $(key).replaceWith(value)
                    })
                    $(document.body).trigger('wc_fragments_refreshed')
                }
            },
            complete: function () {
                cartQtyUpdating = false
                if ($('#order_review').length) {
                    if (newVal <= 0) {
                        window.location.reload()
                        return
                    }
                    $.get(window.location.href, function (html) {
                        var $newReview = $(html).find('#order_review')
                        if ($newReview.length) {
                            $('#order_review').html($newReview.html())
                        }
                    })
                }
            },
        })
    })

    // Product Block Add to Cart
    $(document).on('click', '.produto-card-btn[data-product-id]', function (e) {
        e.preventDefault()
        var $btn = $(this)
        var productId = $btn.data('product-id')
        var qty = parseInt($($btn.data('qty-input')).val(), 10) || 1

        $.post(getWcAjaxUrl('add_to_cart'), {
            product_id: productId,
            quantity: qty,
        }, function (response) {
            if (response.fragments) {
                $.each(response.fragments, function (key, value) {
                    $(key).replaceWith(value)
                })
                $(document.body).trigger('wc_fragments_refreshed')
                $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash])
            }
        })
    })

    // Product Single Buy Now
    $(document).on('click', '.produto-single-btn-primary[data-product-id]', function (e) {
        e.preventDefault()
        var $btn = $(this)
        var productId = $btn.data('product-id')
        var qty = parseInt($($btn.data('qty-input')).val(), 10) || 1

        $.post(getWcAjaxUrl('add_to_cart'), {
            product_id: productId,
            quantity: qty,
        }, function (response) {
            if (response.fragments) {
                var data = typeof alegriaData !== 'undefined' ? alegriaData : {}
                window.location.href = data.isLoggedIn ? (data.checkoutUrl || '/finalizar-compra/') : (data.loginUrl || '/minha-conta/')
            }
        })
    })

    // WooCommerce Open Cart Drawer After Add to Cart
    $(document.body).on('added_to_cart', function () {
        var cartDrawer = document.getElementById('cartDrawer')
        if (cartDrawer && typeof bootstrap !== 'undefined') {
            var offcanvas = bootstrap.Offcanvas.getOrCreateInstance(cartDrawer)
            offcanvas.show()
        }
    })
})
